// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorAttributes = (client) => ({
    /**
     * `GET /vendor/attributes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListAttributes
     * @source packages/modules/b2c-core/src/api/vendor/attributes/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/attributes", { method: "GET", query, headers }),
    /**
     * `GET /vendor/attributes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetAttribute
     * @source packages/modules/b2c-core/src/api/vendor/attributes/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/attributes/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=attributes.js.map